import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PropTypes from "prop-types";

const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 52,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 2,
    color: "#555555",
    "&$checked": {
      transform: "translateX(28px)",
      color: "#60D835",
      "& + $track": {
        backgroundColor: "#E1F9D2",
        opacity: 1,
      },
    },
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: "none",
  },
  track: {
    borderRadius: 12,
    backgroundColor: "#E9E9E9",
    opacity: 1,
    position: "relative",
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "0.6rem",
      fontWeight: "bold",
      color: "#555555",
    },
    "&:before": {
      content: '"YES"',
      left: 6,
    },
    "&:after": {
      content: '"NO"',
      right: 6,
    },
  },
  checked: {},
}))(Switch);

function YesNoToggle({ checked, onChange, disabled = false, ...props }) {
  return (
    <FormControlLabel
      control={
        <CustomSwitch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          color="default"
          inputProps={{ "aria-label": "Yes No Toggle" }}
          {...props}
        />
      }
      label=""
    />
  );
}

YesNoToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default YesNoToggle;
